<div class="loaderContent">
  @if (!this.isLoading2()) {
    <div class="light-shade box rounded-corners" style="width: 100%">
      <div style="padding: 10px">
        <table style="width: 100%; font-size: 0.9em" class="Authorization">
          <tr>
            <td>
              <dx-check-box>
                <dx-validator [validationGroup]="validationGroup">
                  <dxi-validation-rule
                    type="required"
                    message="Authorized signatory delcaration is required"></dxi-validation-rule>
                </dx-validator>
              </dx-check-box>
            </td>
            <td>
              I hereby state that I am listed as an authorized signatory on the credit card account entered above.
            </td>
          </tr>
          <tr style="display: none">
            <td>
              <dx-check-box> </dx-check-box>
            </td>
            <td>
              I hereby accept that any post-payment transaction disputes or chargebacks may result in the reinstatement
              of the obligations paid in this transaction and in an additional charge to cover the cost of the dispute.
            </td>
          </tr>
          <tr>
            <td>
              <dx-check-box>
                <dx-validator [validationGroup]="validationGroup">
                  <dxi-validation-rule type="required" message="Permission to charge is required"></dxi-validation-rule>
                </dx-validator>
              </dx-check-box>
            </td>
            <td>
              I hereby grant permission for {{ site?.site_name }} to charge my credit card account for the fine amount
              <strong>PLUS</strong> a service fee.
            </td>
          </tr>
        </table>
      </div>
    </div>
  } @else {
    <app-loading-div></app-loading-div>
  }
</div>

